import styled from 'styled-components'
import { COLOUR } from '../../__constants__'

export const Logo = styled.img`
    width: 100%;
    height: 100%;

`

export const Paragraph = styled.div`
    font-family: Lato;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.015em;
    text-align: left;
    line-height: 1.5em;
`

export const H4 = styled.div`
    font-family: Lato;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.015em;
    text-align: left;
    line-height: 1.5em;
`

export const Field = styled.div`
        display: flex;
        column-gap: 8px;
        flex-direction: row;
`


export const Link = styled.a`
    font-family: Lato;
    font-size: 14px;
    font-weight: 400px;
    line-height: 16px;
    letter-spacing: 0.015em;
    text-align: left;
    color: ${COLOUR.LINK_COLOUR};
    padding-right: 16px; 
    cursor: pointer;
`

export const FileName = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`

export const MenuItem = styled.div`
    font-family: Mada;
    font-size: 16px;
    cursor: pointer;
    border-radius: 8px;
    font-weight: 400;
    letter-spacing: 0em;
    display: flex;
    flex-direction: row;
    column-gap: 8px;
    text-align: left;
    padding: 12px;    
`
